import {ModifierGroupFragment} from '../../../gql/graphql';
import {ModifierModel} from './Modifier.model';
import {ModelContext} from '../../../types/checkoutApp.types';

export class ModifierGroupModel {
  public id: string;
  public name?: string;
  public modifiers: ModifierModel[];

  constructor(modifierGroup: ModifierGroupFragment, modelContext: ModelContext) {
    this.id = modifierGroup.id!;
    this.name = modifierGroup.name?.translated ?? modifierGroup.name?.original ?? /* istanbul ignore next */ undefined;
    this.modifiers = (modifierGroup.modifiers ?? []).map((modifier) => new ModifierModel(modifier!, modelContext));
  }
}
